import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Tooltip
} from "@material-ui/core";
import { Edit as EditIcon, GetApp as DownloadIcon } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { Image } from "components/Image";
import { MAX_EDIT_COUNT } from "./creativeHelpers";
import type { GeneratedUserCreative } from "../../../@types/sharedSchema";

export type CreativeViewDialogProps = {
  imageUrl: string | null;
  creative: GeneratedUserCreative | null;
  onClose: () => void;
  onEdit: (creative: GeneratedUserCreative) => void;
  onDownload: (imageUrl: string) => void;
};

export function CreativeViewDialog({
  imageUrl,
  creative,
  onClose,
  onEdit,
  onDownload
}: CreativeViewDialogProps): JSX.Element {
  const { t } = useTranslation();

  const editLimitReached = (creative?.editCount ?? 0) >= MAX_EDIT_COUNT;

  return (
    <Dialog open={!!imageUrl} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent sx={{ p: 3, textAlign: "center" }}>
        {imageUrl && (
          <Box
            sx={{
              position: "relative",
              width: "100%",
              maxWidth: "500px",
              margin: "0 auto",
              "&::after": {
                content: '""',
                display: "block",
                paddingBottom: "100%"
              }
            }}
          >
            <Image
              src={imageUrl}
              alt="Creative Preview"
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover"
              }}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("common.close", "סגור")}</Button>
        {creative && (
          <Tooltip
            title={
              editLimitReached
                ? t(
                    "creativesGenerator.editLimitTooltip",
                    "ניתן לערוך קריאטיב עד {{max}} פעמים בלבד, על מנת לשמור על איכות הקריאטיב",
                    { max: MAX_EDIT_COUNT }
                  )
                : ""
            }
          >
            <span>
              <Button
                variant="outlined"
                onClick={() => {
                  onEdit(creative);
                  onClose();
                }}
                startIcon={<EditIcon />}
                sx={{ mr: 1 }}
                disabled={editLimitReached}
              >
                {t("common.edit", "עריכה")}
              </Button>
            </span>
          </Tooltip>
        )}
        {imageUrl && (
          <Button
            variant="contained"
            onClick={() => onDownload(imageUrl)}
            startIcon={<DownloadIcon />}
          >
            {t("creativesGenerator.download", "הורד")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
